import { css } from 'styled-components';

interface ICardContainer {
  active?: boolean;
}

const CardContainer = css`
  opacity: 0.3;
  color: #ffffff;
  margin: 5px 15px;
  .legoCardImageContainer {
    height: 101px;
    padding: 15px;
    background-color: #ffffff;
  }

  ${({ active }: ICardContainer) => active && 'opacity: 1;'}
`;

export default CardContainer;
